import React from 'react';
import {
    List,
    ListItem,
    ListItemText,
    Divider,
    Box,
    Typography
} from '@mui/material';

export default function CareerList({ onMenuSelect, selectedMenu }) {
    const menuItems = [
        { id: 'development-goals', label: 'Development Goals' },
        { id: 'action-plan', label: 'Action Plan' }
    ];

    return (
        <Box>
            
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                mb: 2,
                height: '32px'
            }}>
                <Typography sx={{
                    fontSize: '12px',
                    color: '#666666',
                    fontWeight: 500,
                }}>
                    GOAL PLANNING TOOLS
                </Typography>
            </Box>

            <List sx={{ pt: 0 }}>
                {menuItems.map((item) => (
                     <div key={item.id}>
                    <ListItem button
                        key={item.id}
                        onClick={() => onMenuSelect(item.id)}
                        sx={{
                            borderRadius: 2,
                            mb: 1,
                            cursor: 'pointer',
                            //bgcolor: '#FFFFFF',
                            bgcolor: selectedMenu === item.id ? '#FFFFFF' : 'transparent',
                            border: '2px solid',
                            borderColor: selectedMenu === item.id ? '#3366FF' : 'transparent',
                            transition: 'all 0.2s ease',
                            '&:hover': {
                                bgcolor: selectedMenu === item.id ? '#FFFFFF' : '#F0F0F0',
                            },
                            padding: '12px',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '4px',
                            alignItems: 'flex-start'
                        }}

                    >
                        <Typography sx={{
                            fontSize: '18px',
                            fontWeight: 500,
                            color: '#1A1A1A',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            width: '100%'  // Ensure the typography takes full width of its container
                        }}
                        >
                            {item.label}
                            </Typography>
                        </ListItem>
                    </div>
                ))}
            </List>

        </Box >
    );
}
